var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(-92 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 14,
    height: 14,
    rx: 7,
    transform: "translate(92 242)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(94.673 205.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M2.568,43.865a.213.213,0,0,0-.16-.353H1.861c0-.054-.006-.109-.006-.164a2.471,2.471,0,0,1,4.166-1.8l.771-.9a3.657,3.657,0,0,0-6.123,2.7c0,.055,0,.109,0,.164H.213a.213.213,0,0,0-.16.353l1.04,1.192.218.25.784-.9Z",
    transform: "translate(0)",
    fill: "#a1f3b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M127.519,161.628l-.775-.889-.483-.553-.689.79-.569.653a.213.213,0,0,0,.16.353h.546a2.471,2.471,0,0,1-3.979,1.78l-.771.9a3.657,3.657,0,0,0,5.938-2.682h.461A.213.213,0,0,0,127.519,161.628Z",
    transform: "translate(-118.918 -118.459)",
    fill: "#a1f3b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringIcon);
export default __webpack_public_path__ + "static/media/recurringIcon.0d76fe992293f9e4a37c1f6fe93fa8b8.svg";
export { ForwardRef as ReactComponent };